import React, { createContext, useState, useEffect } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// Create CurrentWorkspace Context
export const WorkspaceContext = createContext();
export const WorkspaceProvider = ({ children }) => {
    const [workspace, setWorkspace] = useState({id:'', name:''});
  
    return (
      <WorkspaceContext.Provider value={{ workspace, setWorkspace }}>
        {children}
      </WorkspaceContext.Provider>
    );
};

// Create CurrentOrg Context
export const OrgContext = createContext();
export const OrgProvider = ({ children }) => {
    const [org, setOrg] = useState({id:'', name:''});
  
    return (
      <OrgContext.Provider value={{ org, setOrg }}>
        {children}
      </OrgContext.Provider>
    );
};

// // Create Search Context
// export const SearchContext = createContext();
// export const SearchProvider = ({ children }) => {
//     const [searchText, setSearchText] = useState('');
  
//     return (
//       <SearchContext.Provider value={{ searchText, setSearchText }}>
//         {children}
//       </SearchContext.Provider>
//     );
// };

// Create ActiveMenuIndex Context
export const ActiveMenuIndexContext = createContext(0);
export const ActiveMenuIndexProvider = ({ children }) => {
    const [activeMenuIndex, setActiveMenuIndex] = useState(0);
    const [activeSubMenuText, setActiveSubMenuText] = useState('');
    return (
        <ActiveMenuIndexContext.Provider value={{ activeMenuIndex, setActiveMenuIndex, activeSubMenuText, setActiveSubMenuText }}>
            {children}
        </ActiveMenuIndexContext.Provider>
    );
};

// Create User Context
export const UserContext = createContext();
export const UserProvider = ({ children }) => {
    const [user, setUser] = useState({id: '', name: '', email: '', workspaceId: '', workspaceName: ''});
  
    return (
      <UserContext.Provider value={{ user, setUser }}>
        {children}
      </UserContext.Provider>
    );
};

// Create Menu Context
export const MenuContext = createContext();
export const MenuProvider = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isMenuCondensed, setIsMenuCondensed] = useState(false);

    return (
        <MenuContext.Provider value={{ isMenuOpen, setIsMenuOpen, isMenuCondensed, setIsMenuCondensed }}>
            {children}
        </MenuContext.Provider>
    );
};

// Create MenuWidth Context
export const MenuWidthContext = createContext(200); // default value, e.g. 220px
export const MenuWidthProvider = ({ children }) => {
    const [menuWidth, setMenuWidth] = useState(200); // or whatever your default is

    return (
        <MenuWidthContext.Provider value={{ menuWidth, setMenuWidth }}>
            {children}
        </MenuWidthContext.Provider>
    );
};

// Create ShowGettingStarted Context
export const ShowGettingStartedContext = createContext();
export const ShowGettingStartedProvider = ({ children }) => {
    const [showGettingStarted, setShowGettingStarted] = useState(false);

    return (
        <ShowGettingStartedContext.Provider value={{ showGettingStarted, setShowGettingStarted }}>
            {children}
        </ShowGettingStartedContext.Provider>
    );
};

// Create SetupTracker Context
export const SetupTrackerContext = createContext();
export const SetupTrackerProvider = ({ children }) => {
    const [setupSteps, setSetupSteps] = useState([
        { id: 1, title: 'Create Account', completed: true },
        { id: 2, title: 'Connect Financial Data', completed: false, path: '/data-sources' },
        { id: 3, title: 'Ask your First Question', completed: false, path: '/forecast' },
        { id: 4, title: 'Build a Dashboard', completed: false, path: '/dashboards' },
        { id: 5, title: 'Invite a Team Member', completed: false, path: '/settings' }
    ]);

    return (
        <SetupTrackerContext.Provider value={{ 
            setupSteps, 
            setSetupSteps
        }}>
            {children}
        </SetupTrackerContext.Provider>
    );
};

// Create Forecast Context
export const ForecastContext = createContext();
export const ForecastProvider = ({ children }) => {
    const [forecasts, setForecasts] = useState([]); // Array of all forecast metadata
    const [currentForecast, setCurrentForecast] = useState(null); // Currently selected forecast metadata (always the base)
    const [compiledForecast, setCompiledForecast] = useState(null); // Fully compiled/hydrated forecast (with calendar, etc.)
    const [components, setComponents] = useState(null); // Forecast components array
    const [componentsLoading, setComponentsLoading] = useState(false); // Loading state
    const [forecastReloadKey, setForecastReloadKey] = useState(0); // Increment to force reload of same forecast
    const [activeScenario, setActiveScenario] = useState(null); // Currently selected scenario name (null = base)
    const [scenarios, setScenarios] = useState([]); // Overlay scenarios for the current base forecast

    // Helper to force reload the current forecast (even if same ID)
    const triggerForecastReload = () => setForecastReloadKey(prev => prev + 1);

    return (
        <ForecastContext.Provider value={{ 
            forecasts, 
            setForecasts,
            currentForecast,
            setCurrentForecast,
            compiledForecast,
            setCompiledForecast,
            components,
            setComponents,
            componentsLoading,
            setComponentsLoading,
            forecastReloadKey,
            triggerForecastReload,
            activeScenario,
            setActiveScenario,
            scenarios,
            setScenarios
        }}>
            {children}
        </ForecastContext.Provider>
    );
};

// Create Combined Context Provider
export const CombinedProvider = ({ children }) => (
    <DndProvider backend={HTML5Backend}>
        <OrgProvider>
            <WorkspaceProvider>
                <ActiveMenuIndexProvider>
                    <UserProvider>
                        <MenuProvider>
                            <MenuWidthProvider>
                                <ShowGettingStartedProvider>
                                    <SetupTrackerProvider>
                                        <ForecastProvider>
                                            {children}
                                        </ForecastProvider>
                                    </SetupTrackerProvider>
                                </ShowGettingStartedProvider>
                            </MenuWidthProvider>
                        </MenuProvider>
                    </UserProvider>
                </ActiveMenuIndexProvider>
            </WorkspaceProvider>
        </OrgProvider>
    </DndProvider>
);